// src/utils/timeUtils.js

export const getTimeAgo = (createdAt, language) => {
  if (!createdAt) return language === 'ar' ? 'غير معروف' : 'Unknown';
  
  const now = new Date();
  const postedDate = createdAt.toDate ? createdAt.toDate() : new Date(createdAt);
  const diffInSeconds = Math.floor((now - postedDate) / 1000);
  
  if (diffInSeconds < 60) {
    return language === 'ar' ? 'الآن' : 'now';
  }
  
  const diffInMinutes = Math.floor(diffInSeconds / 60);
  if (diffInMinutes < 60) {
    return language === 'ar' 
      ? `منذ ${diffInMinutes} دقيقة${diffInMinutes > 10 ? '' : ' '}` 
      : `${diffInMinutes} minute${diffInMinutes > 1 ? 's' : ''} ago`;
  }
  
  const diffInHours = Math.floor(diffInMinutes / 60);
  if (diffInHours < 24) {
    return language === 'ar' 
      ? `منذ ${diffInHours} ساعة${diffInHours > 10 ? '' : ' '}` 
      : `${diffInHours} hour${diffInHours > 1 ? 's' : ''} ago`;
  }
  
  const diffInDays = Math.floor(diffInHours / 24);
  if (diffInDays < 30) {
    return language === 'ar' 
      ? `منذ ${diffInDays} يوم${diffInDays > 10 ? '' : ' '}` 
      : `${diffInDays} day${diffInDays > 1 ? 's' : ''} ago`;
  }
  
  const diffInMonths = Math.floor(diffInDays / 30);
  return language === 'ar' 
    ? `منذ ${diffInMonths} شهر${diffInMonths > 10 ? '' : ' '}` 
    : `${diffInMonths} month${diffInMonths > 1 ? 's' : ''} ago`;
};